<template>
  <div class="projectData">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/CRMange"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div class="content_title">
      <div class="projectData-table">
        <div class="div-pagination">
          <el-pagination
            background
            @current-change="pagingChange"
            :current-page.sync="currentPage"
            :page-size="20"
            layout="total, prev, pager, next, jumper"
            :total="total"
            ref="multipleTable"
          ></el-pagination>
        </div>
        <div class="table" ref="table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            :header-cell-style="tableHeaderCell"
            :cell-style="tableCell"
            :height="tableHeight"
            border
            fit
            tooltip-effect="dark"
          >
            <template>
              <el-table-column
                :prop="item.value"
                :label="item.label"
                v-for="(item, index) in tableColumn"
                :key="index"
                :align="flexWidth(item.label, item.value)"
                :width=" flexColumnWidth(item.label, item.value)
                "
              >
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableColumn: [
        {
          label: "Project code",
          value: "projectCode",
        },
        {
          label: "Project Name (Chinese)",
          value: "posFullNameCN",
        },
        {
          label: "Channel",
          value: "channel",
        },
        {
          label: "New Region",
          value: "newRegion",
        },
        {
          label: "City",
          value: "city",
        },
        {
          label: "Customer split (Belle/YY/RA)",
          value: "CustomerSplit",
        },
        {
          label: "Group Customer",
          value: "GroupCustomer",
        },
        {
          label: "New Format",
          value: "format",
        },
        {
          label: "Action",
          value: "action",
        },
        {
          label: "Support Scheme",
          value: "Support",
        },
        {
          label: "CAPEX or not?",
          value: "CAPEX",
        },
        {
          label: "Space (m2)",
          value: "space",
        },
        {
          label: "Application Date",
          value: "applicationDate",
        },
        {
          label: "Fixture FCST",
          value: "fixtureFCST",
        },
        {
          label: "Fixture (incl. MNQ) Quotation (w/o VAT)",
          value: "FixtureQuotation",
        },
      ],
      total: 100,
      loading: false,
      currentPage: 1,
      pagenum: 20,
      tableHeight: window.innerHeight - 190,
    };
  },
  methods: {
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell() {
      return "background: #FFFFFF;color: #5A5854;padding-left:4px";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    BindData(pageIndex) {
      this.currentPage = pageIndex;
      this.loading = true;
      this.$api
        .get("/CR/GetCrProject", {
          currentPage: pageIndex,
          pagenum: this.pagenum,
        })
        .then((res) => {
          if (res.data.status == true) {
            this.tableData = res.data.content;
            this.total = res.data.total;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    Init() {
      this.BindData(1);
    },
    transferToDecimal(cellvalues) {
      if (!!cellvalues && typeof cellvalues === "number") {
        if (cellvalues > 0) {
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        }
      } else {
        return cellvalues;
      }
    },
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          let c = this.getTextWidth(item);
          if (acc < c) {
            acc = c;
          }
        }
        return acc;
      }, 0);
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop) {
      console.log("1221");
      const arr = this.tableData.map((x) => x[prop]);
      arr.push(label);
      return this.getMaxLength(arr) + 20 + "px";
    },
    flexWidth(label, prop) {
      const arr = this.tableData.map((x) => x[prop]);
      arr.push(label);
      const max = this.getMaxLength(arr);
      if (max > 144) {
        return "left";
      } else {
        return "center";
      }
    },
    getWidth(column) {
      console.log(column);
      return 9 * column.length + 10 + "px";
    },
    isFixColumnfit() {
      const select = document.querySelector(".el-table__body-wrapper")
      if(!select) return true
       const eBodyWarpWidth = document.querySelector(
          ".el-table__body-wrapper"
        ).offsetWidth;
        const eBodyWidth =
          document.querySelector(".el-table__body").offsetWidth;
        if (eBodyWarpWidth >= eBodyWidth) {
          return true;
        } else {
          return false;
        }
    },
  },
  mounted() {
    this.Init();
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
}
.projectData-table {
  width: 100%;

  .div-pagination {
    text-align: right;
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
    padding-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ProjectDatabase.vue